import { render, staticRenderFns } from "./SPCDashboard.vue?vue&type=template&id=588f2c66&scoped=true"
import script from "./SPCDashboard.vue?vue&type=script&lang=js"
export * from "./SPCDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588f2c66",
  null
  
)

export default component.exports